import _extends from "@babel/runtime/helpers/extends";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { Metric } from "../../../../../../../../metric";
import { MenuUrlTarget } from "../../../../../../../../types";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var MainBlock = function MainBlock(_ref) {
  var categories = _ref.categories,
    activeCategory = _ref.activeCategory,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("nav", {
    className: cx('main-block')
  }, categories.map(function (item) {
    return /*#__PURE__*/React.createElement(Metric, {
      asChild: true,
      data: item.title,
      events: {
        headerMetric: ['handleNavLinkClick']
      },
      key: item.title,
      mode: "click"
    }, /*#__PURE__*/React.createElement(Text, _extends({
      className: cx('item'),
      color: (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.title) === item.title ? 'primary-invert' : 'tertiary-invert'
    }, item.url ? {
      href: item.url,
      target: MenuUrlTarget.get(item.isBlankUrlTarget)
    } : {
      onClick: function onClick() {
        return _onClick(item);
      }
    }, {
      role: "link",
      size: "xs",
      tagName: "a"
    }), item.title));
  }));
};